/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeAssociatedArtistsRequestEditsInner
 */
export interface ChangeAssociatedArtistsRequestEditsInner {
    /**
     * 
     * @type {string}
     * @memberof ChangeAssociatedArtistsRequestEditsInner
     */
    artistId: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeAssociatedArtistsRequestEditsInner
     */
    op: ChangeAssociatedArtistsRequestEditsInnerOpEnum;
    /**
     * fa | ofa for add; nfa or null for delete
     * @type {string}
     * @memberof ChangeAssociatedArtistsRequestEditsInner
     */
    featuredStatus?: string | null;
}


/**
 * @export
 */
export const ChangeAssociatedArtistsRequestEditsInnerOpEnum = {
    Add: 'add',
    Delete: 'delete'
} as const;
export type ChangeAssociatedArtistsRequestEditsInnerOpEnum = typeof ChangeAssociatedArtistsRequestEditsInnerOpEnum[keyof typeof ChangeAssociatedArtistsRequestEditsInnerOpEnum];


/**
 * Check if a given object implements the ChangeAssociatedArtistsRequestEditsInner interface.
 */
export function instanceOfChangeAssociatedArtistsRequestEditsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;

    return isInstance;
}

export function ChangeAssociatedArtistsRequestEditsInnerFromJSON(json: any): ChangeAssociatedArtistsRequestEditsInner {
    return ChangeAssociatedArtistsRequestEditsInnerFromJSONTyped(json, false);
}

export function ChangeAssociatedArtistsRequestEditsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeAssociatedArtistsRequestEditsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'artistId': json['artist_id'],
        'op': json['op'],
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
    };
}

export function ChangeAssociatedArtistsRequestEditsInnerToJSON(value?: ChangeAssociatedArtistsRequestEditsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'artist_id': value.artistId,
        'op': value.op,
        'featuredStatus': value.featuredStatus,
    };
}

